import script from "./manage-company-links-modal.vue?vue&type=script&setup=true&lang=ts"
export * from "./manage-company-links-modal.vue?vue&type=script&setup=true&lang=ts"

const __exports__ = script;

export default __exports__